<template>
    <div class="blockout-unblock">
        <!--Block Out / Unblock-->
        <div class="main-container-work-settings">
            <div class="heading-container">
                <!--Title-->
                <div>
                    <h3>{{ $t("adminMenu.blockoutUnblock") }}</h3>
                </div>
            </div>
            <div class="content-work-settings section-wrap blockout-wrap">
                <router-link :to="{ path: '/app/block-out' }">
                    <div class="section-wrap blockout-card">
                        <h5>Block Out</h5>
                        <p>
                            Block certain days you normally work, but you don't want to be booked by clients.
                            <span class="main-text-link">Click here</span>
                        </p>
                    </div>
                </router-link>
                <router-link :to="{ path: '/app/exception-days' }">
                    <div class="section-wrap blockout-card">
                        <h5>Unlock Appt. Times</h5>
                        <p>
                            Choose certain days to unlock-days when you normally don't work.
                            <span class="main-text-link">Click here</span>
                        </p>
                    </div>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "BlockoutUnblock",

    data: function () {
        return {};
    },
    mounted: function () { },
    beforeUnmount() { },
    computed: {},
    methods: {},
    components: {},
};
</script>
